import { useMutation, useQueryClient } from '@tanstack/vue-query';
import type { UserDashboardStartChallengeResponseType } from '@magma-app/magma-types/user-dashboard/challenge';
import { instances } from '@/services/http';

export const useStartChallenge = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (challengeId: number) => {
      const response = await instances.userDashboard.post(
        `challenges/${challengeId}/start`
      );
      return response.data as UserDashboardStartChallengeResponseType;
    },
    onSuccess: () => {
      // Invalidate the challenges query to refresh the list
      queryClient.invalidateQueries({ queryKey: ['challenges'] });
    },
  });
};
